export const LOT_TYPES = {
  VEHICLE: 'ContentfulVehicle',
  AUTOMOBILIA: 'ContentfulAutomobilia',
};

export const VEHICLE_TYPES = {
  CAR: 'Car',
  MOTORCYCLE: 'Motorcycle',
};

export const LOT_TYPES_LABELS = {
  CAR: 'car',
  MOTORCYCLE: 'motorcycle',
  ITEM: 'item',
};

export const DISPLAY_TYPE_IN_FORMS_MESSAGE = {
  car: 'vehicle',
  motorcycle: 'motorcycle',
  item: 'lot',
};
